import { APP_ATTRIBUTION, QUANTUM_FOUNDRY_LOGO } from "@/lib/appMeta";
import { cn } from "@/lib/utils";

export function QuantumFoundryMark({ compact = false, className = "" }) {
  return (
    <img
      src={QUANTUM_FOUNDRY_LOGO}
      alt={APP_ATTRIBUTION}
      title={APP_ATTRIBUTION}
      className={cn("qf-lockup", compact && "qf-lockup-compact", className)}
    />
  );
}
